import React, { useState } from 'react';
import { QrCode, Bell, Car, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const STEPS = [
  {
    icon: <Car className="w-20 h-20 text-white" />,
    bg: 'from-blue-500 to-blue-700',
    title: 'La tua auto potrebbe bloccare qualcuno?',
    body: 'Stampa il QR code e mettilo ben visibile: sul cruscotto lato passeggero o incastrato nel finestrino. Meglio due copie.',
  },
  {
    icon: <QrCode className="w-20 h-20 text-white" />,
    bg: 'from-indigo-500 to-indigo-700',
    title: 'Chi è bloccato scansiona il QR',
    body: 'Nessuna app da installare. Basta aprire la fotocamera del telefono e inquadrare il codice.',
  },
  {
    icon: <Bell className="w-20 h-20 text-white" />,
    bg: 'from-amber-500 to-amber-600',
    title: 'Tu ricevi una notifica',
    body: 'Ricevi una notifica push e una email. Un tocco su "Sto arrivando" avvisa chi aspetta — niente clacson, niente stress.',
  },
];

const Onboarding = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  const next = () => {
    if (isLast) {
      localStorage.setItem('sf_onboarding_done', '1');
      onDone();
    } else {
      setStep(s => s + 1);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Colored top section */}
      <div className={`bg-gradient-to-br ${current.bg} flex-1 flex flex-col items-center justify-center px-8 py-16`}>
        <div className="w-36 h-36 rounded-full bg-white/20 flex items-center justify-center mb-8">
          {current.icon}
        </div>
        <h2 className="text-2xl font-bold text-white text-center leading-tight mb-4">
          {current.title}
        </h2>
        <p className="text-white/90 text-center text-base leading-relaxed">
          {current.body}
        </p>
      </div>

      {/* Bottom section */}
      <div className="bg-white px-8 py-8 flex flex-col items-center space-y-6">
        {/* Dots */}
        <div className="flex space-x-2">
          {STEPS.map((_, i) => (
            <div
              key={i}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === step ? 'w-6 bg-blue-600' : 'w-2 bg-gray-300'
              }`}
            />
          ))}
        </div>

        <Button
          onClick={next}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 text-base font-semibold flex items-center justify-center space-x-2"
        >
          <span>{isLast ? 'Inizia' : 'Avanti'}</span>
          <ChevronRight className="w-5 h-5" />
        </Button>

        {!isLast && (
          <button
            onClick={() => { localStorage.setItem('sf_onboarding_done', '1'); onDone(); }}
            className="text-sm text-gray-400 hover:text-gray-600"
          >
            Salta
          </button>
        )}
      </div>
    </div>
  );
};

export default Onboarding;
